import { useQuery } from '@tanstack/react-query';

import GetFaqCategories from './GetFaqCategories.graphql';
import type { GQLFaqCategoriesResponse } from './types';
import { DataSourceEntry } from '@/types/storyblok';
import { storyblokGraphQLClient } from '@/utils/storyblok';
import getErrorMessage from '@/utils/errors';

export const fetchFaqCategories = async (): Promise<DataSourceEntry[]> => {
    try {
        const { DatasourceEntries }: GQLFaqCategoriesResponse =
            await storyblokGraphQLClient().request(GetFaqCategories);

        return DatasourceEntries.items;
    } catch (error) {
        //TODO: handle logging errors better, reusable fn wrapper
        const errorMessage = getErrorMessage(error);
        console.error({ message: errorMessage });
        throw new Error(errorMessage);
    }
};

export const useFaqCategories = () =>
    useQuery(['faq', 'categories'], fetchFaqCategories);
